<template>
  <div class="sk-container w-full">
    <bg-skeleton-sso v-if="!isMobile" />
    <bg-skeleton-sso-mobile v-else />
    <div class="absolute top-0 left-0 right-0 bottom-0 bg-transparent">
      <div class="h-full w-full flex items-center justify-center">
        <div
          class="card-message flex items-center justify-center h-56 lg:h-64 bg-white w-32 rounded-zt-lg p-3"
        >
          <div class="max-w-sm flex items-center justify-center">
            <div class="relative loading">
              <svg
                width="97"
                height="112"
                viewBox="0 0 97 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M47.8186 0.626378L1.65959 14.4938C0.675086 14.7751 0 15.6752 0 16.7159V67.488C0 87.9094 31.1383 106.052 47.8186 111.256C48.0436 111.312 48.2687 111.369 48.4937 111.369V0.541992C48.2687 0.541992 48.0436 0.570121 47.8186 0.626378Z"
                  fill="#A7ABFF"
                />
                <path
                  d="M95.3278 14.4938L49.1406 0.626378C48.9437 0.570121 48.7187 0.541992 48.4937 0.541992V111.369C48.7187 111.369 48.9718 111.34 49.1969 111.256C65.849 106.052 96.9873 87.9094 96.9873 67.488V16.7159C96.9873 15.6752 96.3123 14.7751 95.3278 14.4938Z"
                  fill="#898DFF"
                />
                <path
                  d="M50.3576 55.0398C60.2463 54.0098 67.4277 45.1584 66.3976 35.2697C65.3676 25.381 56.5162 18.1997 46.6275 19.2297C36.7388 20.2597 29.5574 29.1111 30.5875 38.9998C31.6175 48.8885 40.4689 56.0699 50.3576 55.0398Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M48.4937 59.6123C30.2945 59.6123 15.0207 72.1295 10.8014 89.0067C11.0827 89.3161 11.3921 89.5974 11.7015 89.8787C11.8984 90.0756 12.0953 90.2725 12.2922 90.4694C22.8404 100.483 37.8892 108.162 47.7905 111.256C48.0155 111.313 48.2405 111.369 48.4656 111.369C48.6906 111.369 48.9437 111.341 49.1688 111.256C59.07 108.162 74.1188 100.483 84.667 90.4694C84.8639 90.2725 85.0608 90.0756 85.2577 89.8787C85.5672 89.5974 85.8484 89.288 86.1579 89.0067C81.9667 72.1577 66.6647 59.6123 48.4937 59.6123Z"
                  fill="#F5F5F5"
                />
              </svg>
              <span v-if="processLogin" class="flog-graphic absolute">
                <svg
                  width="58"
                  height="57"
                  viewBox="0 0 58 57"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M47.2842 22.5128L45.9903 19.4468C45.9903 19.4468 49 12.6397 48.7469 12.3865L44.7526 8.50478C44.4713 8.22349 37.6642 11.3458 37.6642 11.3458L34.5138 10.08C34.5138 10.08 31.7291 3.18848 31.3634 3.18848H25.7377C25.3439 3.18848 22.7842 10.1081 22.7842 10.1081L19.6338 11.3739C19.6338 11.3739 12.686 8.4204 12.4328 8.70168L8.43859 12.5834C8.1573 12.8647 11.3358 19.5312 11.3358 19.5312L10.0419 22.5972C10.0419 22.5972 3.00977 25.2976 3.00977 25.6914V31.2046C3.00977 31.5984 10.07 34.1018 10.07 34.1018L11.364 37.1678C11.364 37.1678 8.3542 43.9749 8.60736 44.2281L12.6016 48.138C12.8829 48.4193 19.69 45.297 19.69 45.297L22.8404 46.5909C22.8404 46.5909 25.6252 53.4824 25.9908 53.4824H31.6165C32.0103 53.4824 34.5701 46.5628 34.5701 46.5628L37.7204 45.2689C37.7204 45.2689 44.6401 48.2224 44.9214 47.9692L48.9156 44.0875C49.1969 43.8062 46.0184 37.1397 46.0184 37.1397L47.3123 34.0737C47.3123 34.0737 54.3444 31.3452 54.3444 30.9795V25.4663C54.3444 25.0163 47.2842 22.5128 47.2842 22.5128ZM36.9047 28.2792C36.9047 32.7235 33.2199 36.3521 28.6912 36.3521C24.1625 36.3521 20.4776 32.7235 20.4776 28.2792C20.4776 23.8349 24.1625 20.2344 28.6912 20.2344C33.2199 20.2344 36.9047 23.8349 36.9047 28.2792Z"
                    fill="#2D2D2D"
                  />
                  <path
                    d="M28.6912 17.4209C22.6154 17.4209 17.6648 22.2871 17.6648 28.2785C17.6648 34.2699 22.6154 39.1643 28.6912 39.1643C34.767 39.1643 39.7176 34.298 39.7176 28.2785C39.7176 22.2871 34.767 17.4209 28.6912 17.4209Z"
                    fill="white"
                  />
                  <path
                    d="M54.3726 22.259C53.7537 21.9778 52.8818 21.6121 51.8129 21.1902C50.9409 20.8526 50.0408 20.5151 49.3938 20.29L49.0563 19.4743C49.3376 18.8274 49.7032 17.9835 50.0689 17.1115C50.4908 16.0708 50.8284 15.2269 51.0815 14.5799C51.4753 13.5111 52.1223 11.739 50.6877 10.3888L46.7216 6.50703C45.3433 5.15686 43.6556 5.77568 42.5304 6.19761C41.8835 6.45077 41.0396 6.78832 39.9989 7.23837C39.1269 7.60405 38.2549 7.99785 37.6079 8.27914L36.6797 7.91346C36.3984 7.2665 36.0609 6.39451 35.6671 5.52253C35.217 4.48177 34.8513 3.63792 34.5419 3.04722C34.0356 1.97833 33.248 0.375 31.3634 0.375H25.7377C23.7968 0.375 23.0373 2.00646 22.5591 3.10347C22.2778 3.7223 21.9403 4.56616 21.5184 5.60692C21.1808 6.45078 20.8433 7.29463 20.5901 7.96972L19.6619 8.33539C18.9868 8.0541 18.0867 7.68843 17.1866 7.32276C16.1177 6.90083 15.2457 6.56328 14.5987 6.33826C13.4736 5.94446 11.814 5.38189 10.4638 6.6758L6.49771 10.5575L6.46958 10.5857C5.09128 11.964 5.76636 13.7361 6.16016 14.805C6.41332 15.4238 6.75086 16.2676 7.22905 17.3084C7.59472 18.1523 7.96039 18.968 8.26981 19.5868L7.93226 20.4025C7.25718 20.6557 6.35707 21.0214 5.45695 21.3871C4.38806 21.8371 3.54421 22.2028 2.92538 22.4841C1.82836 22.9904 0.196899 23.7499 0.196899 25.6907V31.2039C0.196899 33.1729 1.88462 33.9043 2.98163 34.4106C3.60046 34.6919 4.47245 35.0294 5.54133 35.4513C6.41332 35.7889 7.31344 36.1264 7.96039 36.3515L8.29794 37.1672C8.01665 37.8141 7.65098 38.658 7.28531 39.53C6.86338 40.5707 6.52584 41.4146 6.27268 42.0616C5.87888 43.1304 5.23192 44.9026 6.63835 46.2527L10.5764 50.1345C11.9547 51.5128 13.6424 50.8658 14.7675 50.4439C15.4145 50.1907 16.2583 49.8532 17.2991 49.4031C18.1711 49.0375 19.0431 48.6437 19.69 48.3624L20.6183 48.728C20.8995 49.375 21.2371 50.247 21.6309 51.119C22.0809 52.1597 22.4466 53.0036 22.756 53.5943C23.2624 54.6632 24.0499 56.2665 25.9346 56.2665H31.5603C33.5012 56.2665 34.2606 54.635 34.7388 53.538C35.0201 52.9192 35.3576 52.0753 35.7796 51.0346C36.1171 50.1626 36.4547 49.3187 36.7078 48.6718L37.6361 48.3061C38.3111 48.5874 39.1831 48.9531 40.1114 49.3187C41.1803 49.7407 42.0522 50.0782 42.6711 50.3032C43.8243 50.697 45.3996 51.2596 46.7497 50.0501L50.8002 46.084L50.8284 46.0558C52.2348 44.6494 51.5316 42.9054 51.1097 41.8365C50.8565 41.2177 50.519 40.3739 50.0408 39.3331C49.6751 38.4892 49.2813 37.6735 49 37.0547L49.3376 36.2389C50.0126 35.9858 50.8846 35.6201 51.7847 35.2544C52.8536 34.8044 53.6975 34.4387 54.3163 34.1574C55.4133 33.6511 57.0448 32.8916 57.0448 30.9789V25.5782C57.2136 23.553 55.2446 22.6528 54.3726 22.259ZM51.4753 29.3193C50.1814 29.8819 48.0718 30.7539 46.2434 31.4571L45.1183 31.879L42.8961 37.2234L43.4306 38.3486C44.2182 40.0363 45.1183 42.0053 45.6808 43.2711L44.1056 44.8182C42.7836 44.3119 40.6458 43.468 38.8175 42.6804L37.7486 42.2303L32.376 44.4244L31.9541 45.5776C31.3071 47.3497 30.4914 49.375 29.957 50.6689H27.6504C27.0597 49.4031 26.1877 47.3216 25.4564 45.5495L25.0063 44.4525L19.6338 42.2585L18.5367 42.7648C16.7928 43.5805 14.7113 44.4525 13.4173 44.9869L11.814 43.4117C12.3203 42.1178 13.1923 40.0644 13.9518 38.3205L14.4581 37.1953L12.1797 31.879L11.0264 31.4571C9.22618 30.8101 7.14466 30.0225 5.85075 29.4881V27.3503C7.14466 26.7877 9.25431 25.9158 11.0827 25.2125L12.2078 24.7906L14.4862 19.4743L13.9518 18.321C13.1642 16.6333 12.2641 14.6643 11.7296 13.3985L13.333 11.8515C14.655 12.3296 16.8209 13.2016 18.6211 13.9892L19.69 14.4393L25.0626 12.2734L25.4845 11.092C26.1315 9.31989 26.9472 7.29463 27.4816 6.00072H29.7882C30.3789 7.2665 31.2509 9.34801 31.9822 11.1201L32.4323 12.2453L37.8048 14.4112L38.9018 13.9049C40.6458 13.0891 42.7273 12.189 44.0213 11.6827L45.5964 13.2298C45.0901 14.5237 44.2182 16.5771 43.4587 18.321L42.9524 19.4462L45.2308 24.7906L46.3841 25.2125C48.1562 25.8314 50.2377 26.619 51.5035 27.1534V29.3193H51.4753Z"
                    fill="white"
                  />
                  <path
                    d="M47.2842 22.5128L45.9903 19.4468C45.9903 19.4468 49 12.6397 48.7469 12.3865L44.7526 8.50478C44.4713 8.22349 37.6642 11.3458 37.6642 11.3458L34.5138 10.08C34.5138 10.08 31.7291 3.18848 31.3634 3.18848H25.7377C25.3439 3.18848 22.7842 10.1081 22.7842 10.1081L19.6338 11.3739C19.6338 11.3739 12.686 8.4204 12.4328 8.70168L8.43859 12.5834C8.1573 12.8647 11.3358 19.5312 11.3358 19.5312L10.0419 22.5972C10.0419 22.5972 3.00977 25.2976 3.00977 25.6914V31.2046C3.00977 31.5984 10.07 34.1018 10.07 34.1018L11.364 37.1678C11.364 37.1678 8.3542 43.9749 8.60736 44.2281L12.6016 48.138C12.8829 48.4193 19.69 45.297 19.69 45.297L22.8404 46.5909C22.8404 46.5909 25.6252 53.4824 25.9908 53.4824H31.6165C32.0103 53.4824 34.5701 46.5628 34.5701 46.5628L37.7204 45.2689C37.7204 45.2689 44.6401 48.2224 44.9214 47.9692L48.9156 44.0875C49.1969 43.8062 46.0184 37.1397 46.0184 37.1397L47.3123 34.0737C47.3123 34.0737 54.3444 31.3452 54.3444 30.9795V25.4663C54.3444 25.0163 47.2842 22.5128 47.2842 22.5128ZM36.9047 28.2792C36.9047 32.7235 33.2199 36.3521 28.6912 36.3521C24.1625 36.3521 20.4776 32.7235 20.4776 28.2792C20.4776 23.8349 24.1625 20.2344 28.6912 20.2344C33.2199 20.2344 36.9047 23.8349 36.9047 28.2792Z"
                    fill="url(#paint0_radial)"
                  />
                  <defs>
                    <radialGradient
                      id="paint0_radial"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.6771 28.3354) rotate(90) scale(25.147 25.6673)"
                    >
                      <stop stop-color="#2D2D2D" />
                      <stop offset="0.59375" stop-color="#565251" />
                      <stop offset="1" stop-color="#2D2D2D" />
                    </radialGradient>
                  </defs>
                </svg>
              </span>
              <span v-if="successLogin" class="success-graphic absolute">
                <svg
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.1263 18.8799C23.0505 18.8799 18.0999 23.7461 18.0999 29.7375C18.0999 35.7289 23.0505 40.6233 29.1263 40.6233C35.202 40.6233 40.1527 35.757 40.1527 29.7375C40.1527 23.7461 35.202 18.8799 29.1263 18.8799Z"
                    fill="white"
                  />
                  <path
                    d="M54.8078 23.718C54.1889 23.4367 53.3169 23.0711 52.2481 22.6491C51.3761 22.3116 50.4759 21.9741 49.829 21.749L49.4915 20.9333C49.7727 20.2863 50.1384 19.4425 50.5041 18.5705C50.926 17.5297 51.2635 16.6859 51.5167 16.0389C51.9105 14.97 52.5575 13.1979 51.1229 11.8478L47.1568 7.96601C45.7785 6.61584 44.0908 7.23467 42.9656 7.6566C42.3187 7.90975 41.4748 8.2473 40.434 8.69736C39.5621 9.06303 38.6901 9.45683 38.0431 9.73812L37.1149 9.37244C36.8336 8.72548 36.496 7.8535 36.1022 6.98151C35.6522 5.94075 35.2865 5.0969 34.9771 4.5062C34.4708 3.43731 33.6832 1.83398 31.7986 1.83398H26.1728C24.232 1.83398 23.4725 3.46544 22.9943 4.56246C22.713 5.18129 22.3755 6.02515 21.9536 7.0659C21.616 7.90976 21.2785 8.75362 21.0253 9.4287L20.0971 9.79437C19.422 9.51309 18.5219 9.14741 17.6218 8.78174C16.5529 8.35981 15.6809 8.02227 15.0339 7.79724C13.9088 7.40344 12.2492 6.84087 10.899 8.13479L6.93289 12.0165L6.90476 12.0447C5.52646 13.423 6.20155 15.1951 6.59535 16.2639C6.8485 16.8828 7.18604 17.7266 7.66423 18.7674C8.0299 19.6112 8.39558 20.427 8.70499 21.0458L8.36744 21.8615C7.69236 22.1147 6.79225 22.4804 5.89213 22.846C4.82324 23.2961 3.97939 23.6618 3.36056 23.9431C2.26354 24.4494 0.63208 25.2088 0.63208 27.1497V32.6629C0.63208 34.6319 2.3198 35.3633 3.41681 35.8696C4.03564 36.1509 4.90763 36.4884 5.97651 36.9103C6.8485 37.2479 7.74862 37.5854 8.39557 37.8104L8.73312 38.6262C8.45183 39.2731 8.08616 40.117 7.72049 40.989C7.29856 42.0297 6.96102 42.8736 6.70786 43.5205C6.31406 44.5894 5.6671 46.3615 7.07353 47.7117L11.0115 51.5935C12.3898 52.9718 14.0775 52.3248 15.2027 51.9029C15.8497 51.6497 16.6935 51.3122 17.7343 50.8621C18.6063 50.4964 19.4782 50.1026 20.1252 49.8214L21.0534 50.187C21.3347 50.834 21.6723 51.706 22.0661 52.578C22.5161 53.6187 22.8818 54.4626 23.1912 55.0533C23.6975 56.1222 24.4851 57.7255 26.3697 57.7255H31.9955C33.9363 57.7255 34.6958 56.094 35.174 54.997C35.4553 54.3782 35.7928 53.5343 36.2148 52.4936C36.5523 51.6216 36.8898 50.7777 37.143 50.1308L38.0712 49.7651C38.7463 50.0464 39.6183 50.4121 40.5466 50.7777C41.6154 51.1997 42.4874 51.5372 43.1063 51.7622C44.2595 52.156 45.8347 52.7186 47.1849 51.5091L51.2354 47.5429L51.2635 47.5148C52.67 46.1084 51.9668 44.3644 51.5448 43.2955C51.2917 42.6767 50.9541 41.8328 50.476 40.7921C50.1103 39.9482 49.7165 39.1325 49.4352 38.5137L49.7727 37.6979C50.4478 37.4448 51.3198 37.0791 52.2199 36.7134C53.2888 36.2634 54.1327 35.8977 54.7515 35.6164C55.8485 35.1101 57.48 34.3506 57.48 32.4379V27.0372C57.6487 25.0119 55.6797 24.1118 54.8078 23.718ZM51.9105 30.7783C50.6166 31.3409 48.507 32.2129 46.6786 32.9161L45.5534 33.338L43.3313 38.6824L43.8657 39.8076C44.6533 41.4953 45.5534 43.4643 46.116 44.7301L44.5408 46.2772C43.2188 45.7708 41.081 44.927 39.2526 44.1394L38.1838 43.6893L32.8112 45.8834L32.3893 47.0366C31.7423 48.8087 30.9266 50.834 30.3921 52.1279H28.0856C27.4949 50.8621 26.6229 48.7806 25.8916 47.0085L25.4415 45.9115L20.0689 43.7174L18.9719 44.2238C17.228 45.0395 15.1464 45.9115 13.8525 46.4459L12.2492 44.8707C12.7555 43.5768 13.6275 41.5234 14.387 39.7794L14.8933 38.6543L12.6149 33.338L11.4616 32.9161C9.66136 32.2691 7.57984 31.4815 6.28593 30.9471V28.8093C7.57984 28.2467 9.68949 27.3747 11.5178 26.6715L12.643 26.2496L14.9214 20.9333L14.387 19.78C13.5994 18.0923 12.6992 16.1233 12.1648 14.8575L13.7681 13.3104C15.0902 13.7886 17.2561 14.6606 19.0563 15.4482L20.1252 15.8983L25.4978 13.7324L25.9197 12.551C26.5666 10.7789 27.3824 8.75362 27.9168 7.4597H30.2234C30.8141 8.72549 31.686 10.807 32.4174 12.5791L32.8675 13.7042L38.24 15.8701L39.337 15.3638C41.081 14.5481 43.1625 13.648 44.4564 13.1417L46.0316 14.6887C45.5253 15.9827 44.6533 18.036 43.8939 19.78L43.3875 20.9052L45.666 26.2496L46.8192 26.6715C48.5913 27.2904 50.6728 28.078 51.9386 28.6124V30.7783H51.9105Z"
                    fill="white"
                  />
                  <path
                    d="M47.7195 23.9708L46.4256 20.9048C46.4256 20.9048 49.4353 14.0977 49.1822 13.8445L45.1879 9.96279C44.9066 9.6815 38.0995 12.8038 38.0995 12.8038L34.9491 11.538C34.9491 11.538 32.1644 4.64648 31.7987 4.64648H26.173C25.7792 4.64648 23.2195 11.5661 23.2195 11.5661L20.0691 12.8319C20.0691 12.8319 13.1213 9.8784 12.8681 10.1597L8.87389 14.0414C8.5926 14.3227 11.7711 20.9892 11.7711 20.9892L10.4772 24.0552C10.4772 24.0552 3.44507 26.7556 3.44507 27.1494V32.6626C3.44507 33.0564 10.5053 35.5598 10.5053 35.5598L11.7993 38.6258C11.7993 38.6258 8.7895 45.4329 9.04266 45.6861L13.0369 49.596C13.3182 49.8773 20.1253 46.755 20.1253 46.755L23.2757 48.0489C23.2757 48.0489 26.0605 54.9404 26.4261 54.9404H32.0519C32.4457 54.9404 35.0054 48.0208 35.0054 48.0208L38.1558 46.7269C38.1558 46.7269 45.0754 49.6804 45.3567 49.4272L49.3509 45.5455C49.6322 45.2642 46.4537 38.5977 46.4537 38.5977L47.7476 35.5317C47.7476 35.5317 54.7798 32.8032 54.7798 32.4375V26.9243C54.7798 26.4743 47.7195 23.9708 47.7195 23.9708ZM37.34 29.7372C37.34 34.1815 33.6552 37.8101 29.1265 37.8101C24.5978 37.8101 20.9129 34.1815 20.9129 29.7372C20.9129 25.2929 24.5978 21.6924 29.1265 21.6924C33.6552 21.6924 37.34 25.2929 37.34 29.7372Z"
                    fill="#2D2D2D"
                  />
                  <path
                    d="M4.68774 29.2861C4.68774 15.8259 15.6449 4.84766 29.1262 4.84766C42.6099 4.84766 53.5647 15.8024 53.5647 29.2861C53.5647 42.7675 42.5864 53.7246 29.1262 53.7246C15.6425 53.7246 4.68774 42.7698 4.68774 29.2861Z"
                    fill="#54CAA6"
                    stroke="white"
                    stroke-width="8"
                  />
                  <path
                    d="M29.1261 5.06641C15.7613 5.06641 4.90649 15.9432 4.90649 29.286C4.90649 42.6508 15.7613 53.5056 29.1261 53.5056C42.4689 53.5056 53.3457 42.6508 53.3457 29.286C53.3457 15.9212 42.4909 5.06641 29.1261 5.06641Z"
                    fill="#54CAA6"
                  />
                  <mask id="path-6-inside-1" fill="white">
                    <path
                      d="M43.1516 20.4351L42.2048 19.4884C41.7645 19.026 40.9718 19.026 40.4654 19.4884C35.5334 24.5084 30.5794 29.4844 25.6254 34.4605C23.0053 31.7743 20.3632 29.1322 17.743 26.49C17.2586 26.0056 16.466 26.0056 15.9816 26.49C15.6734 26.7983 15.3871 27.1286 15.0789 27.4368C14.5945 27.8772 14.5945 28.6918 15.0789 29.1762L24.3484 38.5118C25.3832 39.5686 25.8676 39.5686 26.9025 38.5118C32.2968 33.0514 37.7352 27.6129 43.1296 22.1745C43.636 21.6901 43.636 20.9195 43.1516 20.4351Z"
                    />
                  </mask>
                  <path
                    d="M43.1516 20.4351L42.2048 19.4884C41.7645 19.026 40.9718 19.026 40.4654 19.4884C35.5334 24.5084 30.5794 29.4844 25.6254 34.4605C23.0053 31.7743 20.3632 29.1322 17.743 26.49C17.2586 26.0056 16.466 26.0056 15.9816 26.49C15.6734 26.7983 15.3871 27.1286 15.0789 27.4368C14.5945 27.8772 14.5945 28.6918 15.0789 29.1762L24.3484 38.5118C25.3832 39.5686 25.8676 39.5686 26.9025 38.5118C32.2968 33.0514 37.7352 27.6129 43.1296 22.1745C43.636 21.6901 43.636 20.9195 43.1516 20.4351Z"
                    fill="white"
                  />
                  <path
                    d="M43.1516 20.4351L37.4947 26.092L37.4947 26.092L43.1516 20.4351ZM42.2048 19.4884L36.4117 25.0056L36.479 25.0763L36.548 25.1452L42.2048 19.4884ZM40.4654 19.4884L35.0712 13.5805L34.9109 13.7269L34.7587 13.8818L40.4654 19.4884ZM25.6254 34.4605L19.8986 40.0465L25.5671 45.8579L31.2948 40.1048L25.6254 34.4605ZM17.743 26.49L23.4235 20.8569L23.4117 20.845L23.3999 20.8332L17.743 26.49ZM15.9816 26.49L10.3248 20.8332L10.3248 20.8332L15.9816 26.49ZM15.0789 27.4368L20.4603 33.3563L20.6011 33.2283L20.7357 33.0937L15.0789 27.4368ZM15.0789 29.1762L20.7558 23.5395L20.7458 23.5294L20.7357 23.5193L15.0789 29.1762ZM24.3484 38.5118L30.0645 32.9148L30.0449 32.8948L30.0253 32.875L24.3484 38.5118ZM26.9025 38.5118L21.2113 32.8894L21.1988 32.9021L21.1864 32.9148L26.9025 38.5118ZM43.1296 22.1745L37.5998 16.3934L37.5238 16.4661L37.4498 16.5407L43.1296 22.1745ZM48.8084 14.7783L47.8617 13.8315L36.548 25.1452L37.4947 26.092L48.8084 14.7783ZM47.9979 13.9711C44.2028 9.98629 38.4005 10.5408 35.0712 13.5805L45.8596 25.3963C43.5432 27.5112 39.3261 28.0657 36.4117 25.0056L47.9979 13.9711ZM34.7587 13.8818C29.8484 18.8798 24.9131 23.837 19.956 28.8162L31.2948 40.1048C36.2457 35.1318 41.2184 30.1371 46.1721 25.095L34.7587 13.8818ZM31.3522 28.8745C28.7014 26.1567 26.0123 23.4675 23.4235 20.8569L12.0626 32.1232C14.714 34.7969 17.3092 37.3918 19.8986 40.0465L31.3522 28.8745ZM23.3999 20.8332C19.7913 17.2246 13.9333 17.2246 10.3248 20.8332L21.6385 32.1469C18.9987 34.7867 14.726 34.7867 12.0862 32.1469L23.3999 20.8332ZM10.3248 20.8332C10.0528 21.1052 9.80739 21.37 9.67505 21.5121C9.51014 21.6892 9.45829 21.7437 9.42201 21.78L20.7357 33.0937C21.0077 32.8217 21.2531 32.5569 21.3854 32.4147C21.5503 32.2376 21.6022 32.1832 21.6385 32.1469L10.3248 20.8332ZM9.69749 21.5173C5.56429 25.2747 5.97075 31.3818 9.42202 34.8331L20.7357 23.5193C23.2182 26.0018 23.6247 30.4796 20.4603 33.3563L9.69749 21.5173ZM9.40197 34.8129L18.6715 44.1485L30.0253 32.875L20.7558 23.5395L9.40197 34.8129ZM18.6323 44.1088C19.0092 44.4937 21.5349 47.3044 25.6254 47.3044C29.7159 47.3044 32.2416 44.4937 32.6185 44.1088L21.1864 32.9148C21.0768 33.0266 21.3526 32.7172 21.9101 32.3616C22.5456 31.9562 23.8395 31.3044 25.6254 31.3044C27.4113 31.3044 28.7052 31.9562 29.3407 32.3616C29.8983 32.7172 30.174 33.0266 30.0645 32.9148L18.6323 44.1088ZM32.5936 44.1341C37.9891 38.6726 43.3758 33.2863 48.8094 27.8083L37.4498 16.5407C32.0947 21.9395 26.6045 27.4301 21.2113 32.8894L32.5936 44.1341ZM48.6594 27.9557C52.4347 24.3444 52.4409 18.4107 48.8084 14.7783L37.4947 26.092C34.8311 23.4283 34.8373 19.0358 37.5998 16.3934L48.6594 27.9557Z"
                    fill="white"
                    mask="url(#path-6-inside-1)"
                  />
                  <path
                    d="M43.4155 20.4351L42.4907 19.4884C42.0504 19.026 41.2357 19.026 40.7513 19.4884C35.8193 24.5084 30.8653 29.4844 25.9113 34.4605C23.2912 31.7743 20.649 29.1322 18.0289 26.49C17.5445 26.0056 16.7519 26.0056 16.2675 26.49C15.9592 26.7983 15.673 27.1286 15.3648 27.4368C14.8804 27.8772 14.8804 28.6918 15.3648 29.1762L24.6343 38.5118C25.6691 39.5686 26.1535 39.5686 27.1883 38.5118C32.5827 33.0514 38.0211 27.6129 43.4155 22.1745C43.8998 21.6901 43.8998 20.9195 43.4155 20.4351Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span v-if="errorLogin" class="error-graphic absolute">
                <svg
                  width="58"
                  height="58"
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.1263 18.4238C23.0505 18.4238 18.0999 23.2901 18.0999 29.2815C18.0999 35.2728 23.0505 40.1672 29.1263 40.1672C35.202 40.1672 40.1527 35.301 40.1527 29.2815C40.1527 23.2901 35.202 18.4238 29.1263 18.4238Z"
                    fill="white"
                  />
                  <path
                    d="M54.8078 23.261C54.1889 22.9797 53.3169 22.614 52.2481 22.1921C51.3761 21.8546 50.4759 21.517 49.829 21.292L49.4915 20.4763C49.7727 19.8293 50.1384 18.9854 50.5041 18.1135C50.926 17.0727 51.2635 16.2288 51.5167 15.5819C51.9105 14.513 52.5575 12.7409 51.1229 11.3907L47.1568 7.50898C45.7785 6.15881 44.0908 6.77764 42.9656 7.19957C42.3187 7.45272 41.4748 7.79027 40.434 8.24033C39.5621 8.606 38.6901 8.9998 38.0431 9.28109L37.1149 8.91541C36.8336 8.26845 36.496 7.39647 36.1022 6.52448C35.6522 5.48372 35.2865 4.63987 34.9771 4.04917C34.4708 2.98028 33.6832 1.37695 31.7986 1.37695H26.1728C24.232 1.37695 23.4725 3.00841 22.9943 4.10543C22.713 4.72425 22.3755 5.56811 21.9536 6.60887C21.616 7.45273 21.2785 8.29659 21.0253 8.97167L20.0971 9.33734C19.422 9.05605 18.5219 8.69038 17.6218 8.32471C16.5529 7.90278 15.6809 7.56524 15.0339 7.34021C13.9088 6.94641 12.2492 6.38384 10.899 7.67776L6.93289 11.5595L6.90476 11.5876C5.52646 12.9659 6.20155 14.738 6.59535 15.8069C6.8485 16.4257 7.18604 17.2696 7.66423 18.3104C8.0299 19.1542 8.39558 19.9699 8.70499 20.5888L8.36744 21.4045C7.69236 21.6577 6.79225 22.0233 5.89213 22.389C4.82324 22.8391 3.97939 23.2047 3.36056 23.486C2.26354 23.9923 0.63208 24.7518 0.63208 26.6927V32.2059C0.63208 34.1749 2.3198 34.9062 3.41681 35.4125C4.03564 35.6938 4.90763 36.0314 5.97651 36.4533C6.8485 36.7908 7.74862 37.1284 8.39557 37.3534L8.73312 38.1691C8.45183 38.8161 8.08616 39.66 7.72049 40.5319C7.29856 41.5727 6.96102 42.4166 6.70786 43.0635C6.31406 44.1324 5.6671 45.9045 7.07353 47.2547L11.0115 51.1364C12.3898 52.5147 14.0775 51.8678 15.2027 51.4458C15.8497 51.1927 16.6935 50.8551 17.7343 50.4051C18.6063 50.0394 19.4782 49.6456 20.1252 49.3643L21.0534 49.73C21.3347 50.377 21.6723 51.2489 22.0661 52.1209C22.5161 53.1617 22.8818 54.0055 23.1912 54.5962C23.6975 55.6651 24.4851 57.2685 26.3697 57.2685H31.9955C33.9363 57.2685 34.6958 55.637 35.174 54.54C35.4553 53.9212 35.7928 53.0773 36.2148 52.0365C36.5523 51.1646 36.8898 50.3207 37.143 49.6737L38.0712 49.3081C38.7463 49.5894 39.6183 49.955 40.5466 50.3207C41.6154 50.7426 42.4874 51.0802 43.1063 51.3052C44.2595 51.699 45.8347 52.2616 47.1849 51.052L51.2354 47.0859L51.2635 47.0578C52.67 45.6513 51.9668 43.9074 51.5448 42.8385C51.2917 42.2197 50.9541 41.3758 50.476 40.335C50.1103 39.4912 49.7165 38.6755 49.4352 38.0566L49.7727 37.2409C50.4478 36.9877 51.3198 36.6221 52.2199 36.2564C53.2888 35.8063 54.1327 35.4407 54.7515 35.1594C55.8485 34.6531 57.48 33.8936 57.48 31.9809V26.5802C57.6487 24.5549 55.6797 23.6548 54.8078 23.261ZM51.9105 30.3213C50.6166 30.8838 48.507 31.7558 46.6786 32.459L45.5534 32.881L43.3313 38.2254L43.8657 39.3505C44.6533 41.0383 45.5534 43.0073 46.116 44.273L44.5408 45.8201C43.2188 45.3138 41.081 44.4699 39.2526 43.6823L38.1838 43.2323L32.8112 45.4263L32.3893 46.5796C31.7423 48.3517 30.9266 50.3769 30.3921 51.6709H28.0856C27.4949 50.4051 26.6229 48.3236 25.8916 46.5515L25.4415 45.4544L20.0689 43.2604L18.9719 43.7667C17.228 44.5825 15.1464 45.4545 13.8525 45.9889L12.2492 44.4137C12.7555 43.1198 13.6275 41.0664 14.387 39.3224L14.8933 38.1973L12.6149 32.881L11.4616 32.459C9.66136 31.8121 7.57984 31.0245 6.28593 30.49V28.3523C7.57984 27.7897 9.68949 26.9177 11.5178 26.2145L12.643 25.7926L14.9214 20.4763L14.387 19.323C13.5994 17.6353 12.6992 15.6663 12.1648 14.4005L13.7681 12.8534C15.0902 13.3316 17.2561 14.2036 19.0563 14.9912L20.1252 15.4412L25.4978 13.2753L25.9197 12.0939C26.5666 10.3218 27.3824 8.29659 27.9168 7.00267H30.2234C30.8141 8.26846 31.686 10.35 32.4174 12.1221L32.8675 13.2472L38.24 15.4131L39.337 14.9068C41.081 14.0911 43.1625 13.191 44.4564 12.6846L46.0316 14.2317C45.5253 15.5256 44.6533 17.579 43.8939 19.323L43.3875 20.4481L45.666 25.7926L46.8192 26.2145C48.5913 26.8333 50.6728 27.6209 51.9386 28.1554V30.3213H51.9105Z"
                    fill="white"
                  />
                  <path
                    d="M47.7195 23.5138L46.4256 20.4478C46.4256 20.4478 49.4353 13.6407 49.1822 13.3875L45.1879 9.50576C44.9066 9.22447 38.0995 12.3467 38.0995 12.3467L34.9491 11.081C34.9491 11.081 32.1644 4.18945 31.7987 4.18945H26.173C25.7792 4.18945 23.2195 11.1091 23.2195 11.1091L20.0691 12.3749C20.0691 12.3749 13.1213 9.42137 12.8681 9.70266L8.87389 13.5844C8.5926 13.8657 11.7711 20.5322 11.7711 20.5322L10.4772 23.5982C10.4772 23.5982 3.44507 26.2985 3.44507 26.6923V32.2055C3.44507 32.5993 10.5053 35.1028 10.5053 35.1028L11.7993 38.1688C11.7993 38.1688 8.7895 44.9759 9.04266 45.2291L13.0369 49.1389C13.3182 49.4202 20.1253 46.298 20.1253 46.298L23.2757 47.5919C23.2757 47.5919 26.0605 54.4834 26.4261 54.4834H32.0519C32.4457 54.4834 35.0054 47.5637 35.0054 47.5637L38.1558 46.2698C38.1558 46.2698 45.0754 49.2233 45.3567 48.9702L49.3509 45.0884C49.6322 44.8071 46.4537 38.1407 46.4537 38.1407L47.7476 35.0746C47.7476 35.0746 54.7798 32.3462 54.7798 31.9805V26.4673C54.7798 26.0172 47.7195 23.5138 47.7195 23.5138ZM37.34 29.2802C37.34 33.7245 33.6552 37.3531 29.1265 37.3531C24.5978 37.3531 20.9129 33.7245 20.9129 29.2802C20.9129 24.8358 24.5978 21.2354 29.1265 21.2354C33.6552 21.2354 37.34 24.8358 37.34 29.2802Z"
                    fill="#2D2D2D"
                  />
                  <path
                    d="M4.68774 28.8291C4.68774 15.3689 15.6449 4.39062 29.1262 4.39062C42.6099 4.39062 53.5647 15.3454 53.5647 28.8291C53.5647 42.3104 42.5864 53.2676 29.1262 53.2676C15.6425 53.2676 4.68774 42.3128 4.68774 28.8291Z"
                    fill="#54CAA6"
                    stroke="white"
                    stroke-width="8"
                  />
                  <path
                    d="M29.1261 4.60938C15.7613 4.60938 4.90649 15.4862 4.90649 28.829C4.90649 42.1938 15.7613 53.0485 29.1261 53.0485C42.4689 53.0485 53.3457 42.1938 53.3457 28.829C53.3457 15.4642 42.4909 4.60938 29.1261 4.60938Z"
                    fill="#F15A5C"
                  />
                  <path
                    d="M31.2854 29.2919C34.1176 26.2183 36.9497 23.1446 39.7819 20.0709C40.9675 18.7756 39.0355 16.8216 37.828 18.1389C35.0836 21.1248 32.3173 24.1106 29.5729 27.1184C26.8505 24.1545 24.1281 21.2126 21.4057 18.2487C20.1982 16.9533 18.2662 18.8854 19.4737 20.1807C22.2839 23.2544 25.1161 26.3061 27.9483 29.3797C25.1161 32.4534 22.2839 35.5271 19.4518 38.6008C18.2662 39.8961 20.1982 41.8501 21.3838 40.5328C24.1281 37.5469 26.8944 34.5611 29.6388 31.5533C32.3612 34.5172 35.0836 37.4591 37.806 40.423C39.0135 41.7184 40.9455 39.7863 39.738 38.491C36.9278 35.4173 34.1176 32.3656 31.2854 29.2919Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
            <div class="ml-6 lx:ml-12 text-2xl text-zt-dark-300 text-zt-lg text-message">
              {{ messageRedirect }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, filter, find, map } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import Users from '@/apiClient/Users'
import SichernIntegration from '@/apiClient/SichernIntegration'
import BgSkeletonSso from './bgSkeletonSSO'
import BgSkeletonSsoMobile from './bgSkeletonSSOMobile'
import { useWindowResize } from '@sichern/ui-elements'
export default {
  name: 'authSSO',
  components: { BgSkeletonSso, BgSkeletonSsoMobile },
  data() {
    return {
      userEmployee: {},
      jwt: '',
      messageRedirect: '',
      processLogin: false,
      successLogin: false,
      errorLogin: false,
      windowSize: useWindowResize(this)
    }
  },
  computed: {
    isMobile() {
      return this.windowSize.width < 1024
    },
  },
  created() {
    this.user = new Users()
    this.vi = new SichernIntegration()
  },
  mounted() {
    this.tokenExternalAuthentication()
  },
  methods: {
    ...mapActions({
      setJWT: 'setJwt',
      setCheckUserEmployee: 'setCheckUserEmployee',
      setUsersRelated: 'setUsersRelated',
      getProfile: 'getProfile',
      getUserRelated: 'getUserRelated',
      getProfileByIdPatchUserRelated: 'getProfileByIdPatchUserRelated',
      setActions: 'setActions',
      setStateNotOnBoarding: 'setStateNotOnboarding',
      setUser: 'setUser',
      setParamLoginFactory: 'auth/setParamLoginFactory',
      setHasIntegrationSichernPeople: 'setHasIntegrationSichernPeople',
      clearState: 'clearState',
      setPayrollStatus: 'setPayrollStatus'
    }),

    async tokenExternalAuthentication() {
      try {
        const externalToken = window.localStorage.getItem('__EXTERNAL_JWT__')
        if (!externalToken) {
          return this.errorHandler('No se encontró token externo (__EXTERNAL_JWT__)')
        }
        this.jwt = externalToken
        window.localStorage.setItem('jwt', externalToken)
        await this.$store.dispatch('setJwt', { jwt: externalToken })
        await this.$nextTick()
        this.processLogin = true
        await this.tokenExternalLoginSuccess()
      } catch (e) {
        this.errorHandler('Fallo inicial de autenticación SSO')
      }
    },
    async tokenExternalLoginSuccess() {
      try {
        const { factory } = this.$route.query
        this.$iframeMessages.setAuthenticated(true)
          let userRelatedEmpty = await this.getListUserRelated()
      
          if (userRelatedEmpty) return this.errorHandler()
           if (factory) {
            localStorage.setItem('factory', factory)
            await this.setUserEmployeeByFactory(factory)
          } else {
            await this.setUserEmployee()
          }
          if (this.userEmployee && this.userEmployee.estado_empresa === 2) {
            return this.verifyUserOnBoarding()
          }
          // await this.checkActiveSichernPeopleIntegration()
          // await this.setPayrollStatus()
          await this.setActions({ replace: true })
          await this.setStateNotOnBoarding(true)
        this.messageRedirect = this.$t()
        this.processLogin = false
        this.successLogin = true

        window.localStorage.removeItem('__EXTERNAL_JWT__')
        setTimeout(() => {
          this.toAccess()
        }, 1200)
      } catch (e) {
        this.errorHandler()
      }
    },

    async getListUserRelated() {
      try {

        const userProfile = await this.getProfile()
        
        if (!userProfile || !userProfile.id) return this.errorHandler()
        
        const listUserRelated = await this.getUserRelated()
        
        this.usersEmployeeRelated = filter(listUserRelated, userRelated =>
          find(userRelated.perfiles, profile => profile.id_perfil_tipo === 1)
        )
        
        if (isEmpty(this.usersEmployeeRelated)) {
          return true
        }

        this.userEmployee = find(this.usersEmployeeRelated, user => user.id === userProfile.id)

        if (!this.userEmployee) {
          return true
        }

        await this.setCheckUserEmployee(true)
        await this.setUsersRelated({
          usersRelated: this.usersEmployeeRelated
        })
      } catch (error) {
        throw error
      }
    },

    findDateLastSessionUser(listUserRelated) {
      const userListToLogin = listUserRelated.filter(u => !u.blockedByPayment)
      const userWithOutLastSession = find(userListToLogin, u => isEmpty(u.ultimasession))
      const LastSessionUser = new Date(
        Math.max.apply(
          null,
          map(userListToLogin, u => {
            if (!isEmpty(u.ultimasession)) {
              return new Date(
                moment(u.ultimasession, 'DD-MM-YYYY hh:mm:ss').format()
              )
            } else return ''
          })
        )
      )
      const userWithLastSession = filter(
        userListToLogin,
        u =>
          new Date(
            moment(u.ultimasession, 'DD-MM-YYYY hh:mm:ss').format()
          ).getTime() === LastSessionUser.getTime()
      )[0]
      return userWithOutLastSession ? userWithOutLastSession : userWithLastSession
    },

    async setUserEmployeeByFactory(factory) {
      try {
        this.setParamLoginFactory(factory)
        this.userEmployee = find(this.usersEmployeeRelated, user => {
          return user.empresa.id === parseInt(factory, 10)
        })
        const {
          data: { code }
        } = await this.getProfileByIdPatchUserRelated(this.userEmployee.id)
        this.codePasswordExpired = code
        this.setUser({ user: this.userEmployee })
      } catch (error) {
        this.handleErrors(error)
        await this.$router.push({ name: 'login' })
      }
    },
    async checkActiveSichernPeopleIntegration() {
      const type = 'VP_ABSENCES_HOLIDAYS'
      try {
        const res = await this.vi.checkIntegrationSichernPeople(type)
        this.hasIntegrationSichernPeople = res.data.data.enabled
        this.setHasIntegrationSichernPeople(this.hasIntegrationSichernPeople)
      } catch (error) {
        this.setHasIntegrationSichernPeople(false)
      }
    },
    async setUserEmployee() {
      try {
        const {
          data: { code }
        } = await this.getProfileByIdPatchUserRelated(this.userEmployee.id)

        this.codePasswordExpired = code
        this.setUser({ user: this.userEmployee })
      } catch (error) {
        this.handleErrors(error)
      }
    },

    verifyUserOnBoarding() {
      localStorage.setItem('jwt', this.$store.getters.getJwt)
      location.replace(
        window.location.origin + '/s/home/' + this.$store.getters.getUser.id
      )
      this.$store.dispatch('clearState')
    },
    async toAccess() {
      try {
        this.successLogin = false
        const user = this.$store.state.user || {}
        const perfiles = Array.isArray(user.perfiles) ? user.perfiles : []

        window.location.href = window.origin + '/v3/'
        return
      } catch (e) {
        this.errorHandler('Fallo redirigiendo a la aplicación')
      }
    },

    errorHandler(msgErrorCustom) {
      const fallback = this.$t
        ? this.$t('message.loginComponent.sso.msgRedirectErrorLogin')
        : 'Error en autenticación SSO'
      this.messageRedirect = msgErrorCustom || fallback
      this.$store.dispatch('resetStore') 
      this.errorLogin = true
      this.processLogin = false
      this.successLogin = false
      setTimeout(() => {
        if (!localStorage.getItem('jwt')) {
          this.$router.push({ name: 'auth' }).catch(()=>{})
        }
      }, 2500)
    }
  }
}
</script>

<style scoped lang="scss">
.sk-container {
  background-color: #f5f5f5;
}
.card-message {
  flex-basis: 25%;
  flex-shrink: 0;
  flex-grow: 0;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 6px 10px 0 rgba(0, 0, 0, 0.14);
}
.flog-graphic {
  right: -10px;
  bottom: -10px;
  animation: spin 4s linear infinite;
}
.error-graphic,
.success-graphic {
  right: -10px;
  bottom: -10px;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1200px) {
  .card-message {
    flex-basis: 45%;
    height: auto;
  }

  .text-message {
    font-size: 1.25rem !important;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .card-message {
    flex-basis: 75%;
    height: auto;
  }

  .text-message {
    font-size: 1rem !important;
    text-align: center;
  }

  .card-message > .relative > svg:first-of-type {
    width: 4.6rem;
    height: auto;
  }

  .flog-graphic,
  .error-graphic,
  .success-graphic {
    right: -6px;
    bottom: -6px;
  }

  .flog-graphic svg,
  .error-graphic svg,
  .success-graphic svg {
    width: 2.8rem;
    height: 2.8rem;
  }
}
</style>
